/**
 * Decorative SVG organic shapes echoing the logo's floral/leaf motif.
 * Used as background accents — never as primary imagery.
 */

export function LeafBranch({ className = "", color = "#8DAA91", opacity = 0.5 }) {
  return (
    <svg
      viewBox="0 0 220 220"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      <path
        d="M30 180 C 70 160, 110 150, 150 110 C 175 85, 190 55, 195 30"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />
      {[
        { x: 60, y: 175, r: 16, rot: 30 },
        { x: 95, y: 158, r: 18, rot: 55 },
        { x: 125, y: 138, r: 20, rot: 80 },
        { x: 150, y: 110, r: 22, rot: 110 },
        { x: 175, y: 80, r: 18, rot: 135 },
      ].map((leaf, i) => (
        <ellipse
          key={i}
          cx={leaf.x}
          cy={leaf.y}
          rx={leaf.r * 1.3}
          ry={leaf.r * 0.55}
          fill={color}
          transform={`rotate(${leaf.rot} ${leaf.x} ${leaf.y})`}
        />
      ))}
    </svg>
  );
}

export function BlobShape({ className = "", color = "#2A7B76", opacity = 0.12 }) {
  return (
    <svg
      viewBox="0 0 400 400"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      <path
        fill={color}
        d="M321.5,278Q299,316,255.5,335.5Q212,355,168,341Q124,327,87.5,290.5Q51,254,52,200Q53,146,87.5,108Q122,70,170.5,53Q219,36,261,68Q303,100,328.5,150Q354,200,338,250Q322,300,321.5,278Z"
      />
    </svg>
  );
}

export function FloralAccent({ className = "", color = "#2A7B76", opacity = 0.18 }) {
  return (
    <svg
      viewBox="0 0 200 200"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      <g transform="translate(100 100)">
        {Array.from({ length: 6 }).map((_, i) => (
          <ellipse
            key={i}
            cx="0"
            cy="-40"
            rx="14"
            ry="40"
            fill={color}
            transform={`rotate(${i * 60})`}
          />
        ))}
        <circle r="10" fill={color} opacity="0.6" />
      </g>
    </svg>
  );
}
